export default __webpack_public_path__ + "static/media/Mega ICBC.32610c9f.png";